import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY,
  CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
  DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
  FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
  SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY,
  UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
} from './graphql'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'

const accommodationAgeGroupedTotalCapacityModel: EntityModel = {
  name: 'ageGroupedTotalCapacity',
  namePlural: 'ageGroupedTotalCapacities',
  uniqueName: 'accommodationAgeGroupedTotalCapacity',
  uniqueNamePlural: 'accommodationAgeGroupedTotalCapacities',
  path: 'travel/pricing/accommodation/age_grouped_total_capacity',
  baseUrl: '/travel/pricing/accommodation/age_grouped_total_capacities',
  translationPrefix: 'entities:accommodationAgeGroupedTotalCapacity.',
  getDisplayName: (values: any) => {
    return 'Age Grouped Total Capacity'
  },
  gql: {
    getAll: ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY,
    getSingle: SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY,
    create: CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
    update: UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
    delete: DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
    forceDelete: FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
  },
  attributes: {
    ageGroups: {
      name: 'ageGroups',
      label: 'entities:accommodationAgeGroupedTotalCapacity.attributes.ageGroups.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    capacity: {
      name: 'capacity',
      label: 'entities:accommodationAgeGroupedTotalCapacity.attributes.capacity.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
  },
}

export default accommodationAgeGroupedTotalCapacityModel
